/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { StackOverflowBadgeCountsSchema } from './stackOverflowBadgeCountsSchema';

export interface StackOverflowUserSchema {
  user_id: number;
  display_name: string;
  profile_image?: string | null;
  link: string;
  reputation?: number;
  badge_counts: StackOverflowBadgeCountsSchema;
  creation_date: number;
}
